const months = {
    abbr : [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec' ],
    full : [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ]
};

const pad = value => value < 10 ? `0${ value }` : `${ value }` ;

// parse a date in yyyy-mm-dd format
function parseDate(input) {
    var parts = input.split('-');
    // new Date(year, month [, day [, hours[, minutes[, seconds[, ms]]]]])
    if( parts.length === 2 ){ return new Date( parts[0], parts[1]-1 ) };
    return new Date(parts[0], parts[1]-1, parts[2]); // Note: months are 0-based
};

const getPaddedDate = date => {
    if( !date ){ return null };
    return pad( parseDate( date ).getDate() );
};
const getMonth = date => {
    if( !date ){ return null };
    return parseDate( date.split('T')[0] ).getMonth() + 1;
};
const getYear = date => {
    if( !date ){ return null };
    return parseDate( date.split('T')[0] ).getFullYear();
};
const getAbbrMonthYear = date => {
    if( !date ){ return null };
    let d = parseDate( date.split('T')[0] );
    return `${ months.abbr[ d.getMonth() ] } ${ d.getFullYear() }`;
};
const getFullMonthYear = date => {
    if( !date ){ return null };
    let d = parseDate( date.split('T')[0] );
    return `${ months.full[ d.getMonth() ] } ${ d.getFullYear() }`;
};

export {
    parseDate,
    getMonth,
    getYear,
    getAbbrMonthYear,
    getFullMonthYear,
    getPaddedDate
}


// WEBPACK FOOTER //
// src/client/helpers/common/date-util.js